class Heap {
    constructor() {
        if (
            typeof Settings.services['heap'] !== 'undefined' &&
            Settings.services['heap']['enabled'] === true
        ) {
            this.heap = window['heap'] || (window['heap'] = []);
            this.isEnabled = true;
        } else {
            this.heap = [];
            this.isEnabled = false;
        }
    }

    identify(email) {
        return new Promise(async (resolve, reject) => {
            if (!this.isEnabled) {
                return resolve('Heap is not enabled.');
            }

            try {
                await this.heap.identify(email.toLowerCase());

                resolve();
            } catch (error) {
                reject(error);
            }
        });
    }

    getIdentity() {
        try {
            return this.heap.identity;
        } catch (error) {
            return 'Unknown Heap identity';
        }
    }

    addUserProperties(properties) {
        return new Promise(async (resolve, reject) => {
            if (!this.isEnabled) {
                return resolve('Heap is not enabled.');
            }

            try {
                await this.heap.addUserProperties(properties);

                resolve();
            } catch (error) {
                reject(error);
            }
        });
    }

    addEventProperties(properties) {
        return new Promise(async (resolve, reject) => {
            if (!this.isEnabled) {
                return resolve('Heap is not enabled.');
            }

            try {
                await this.heap.addEventProperties(properties);

                resolve();
            } catch (error) {
                reject(error);
            }
        });
    }
}

export default new Heap();
